const isIncludesWithLower = (string, sub) => (string || '').includes(string?.toLowerCase?.(), sub?.toLowerCase?.());

export default isIncludesWithLower;
